import React from "react";
import { Typography, Card, CardActionArea, CardHeader, CardContent, CardMedia } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import {} from "@material-ui/core/colors";

const useStyles = makeStyles({
  card: {
    maxWidth: 500,
    float: "right",
  },
  media: {
    height: 400, // necessory for card image
  },
  cardHeader: {
    backgroundColor: "#3F51B5",
    color: "#FFFFFF",
  },
});

export const StrokePrevention = () => {
  const classes = useStyles();
  return (
    <div>
      <Typography variant="h3">Stroke prevention</Typography>
      <ul>
        <li>
          Continuous telemetry, if no atrial fibrillation noted during hospital stay, order outpatient 30day cardiac
          event monitor if need.
        </li>
        <li>Allow HTN (SBP up to 220) for the first 24-48 hours, then slowly achieve long term goal &lt; 140/90.</li>
        <li>A1C goal &lt; 6.5). diabetic education diet management. </li>
        <li> Lipid profile LDL (goal &lt; 70).</li>
        <li>Quit smoking.</li>
        <li> Dietician referral, lifestyle intervention, nutrition and weight management.</li>
        <li>
          Recommend engaging in regular physical exercise per therapy recommendations. Secondary Stroke Prevention
          deferred to primary team and primary care physician
        </li>
      </ul>
    </div>
  );
};
